import { useEffect } from "react";

const IOS_APP_URL = "https://apps.apple.com/us/app/gasman4u/id6806303858";
const ANDROID_APP_URL = "https://play.google.com/store/apps/details?id=com.ls.gasman";
const FALLBACK_URL = "https://gasman4u.shop/";

export const getAppDownloadUrl = (userAgent, platform, maxTouchPoints = 0) => {
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isIPadOS = platform === "MacIntel" && maxTouchPoints > 1;

  if (isIOS || isIPadOS) return IOS_APP_URL;
  if (/Android/i.test(userAgent)) return ANDROID_APP_URL;
  return FALLBACK_URL;
};

const GetAppRedirect = () => {
  useEffect(() => {
    const destination = getAppDownloadUrl(
      window.navigator.userAgent,
      window.navigator.platform,
      window.navigator.maxTouchPoints
    );
    window.location.replace(destination);
  }, []);

  return (
    <main className="min-h-screen bg-[#f8fafc] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="mx-auto mb-5 h-10 w-10 rounded-full border-4 border-[#0A4CAE]/20 border-t-[#0A4CAE] animate-spin" />
        <h1 className="text-xl font-bold text-gray-900">Opening GasMan4U…</h1>
        <p className="mt-2 text-sm text-gray-600">Taking you to the right app store.</p>
        <a href={FALLBACK_URL} className="inline-block mt-5 text-sm font-semibold text-[#0A4CAE] hover:underline">
          Return to GasMan4U
        </a>
      </div>
    </main>
  );
};

export default GetAppRedirect;
